import { G } from '../core/state';
import { S } from '../core/constants';
import { draw_text } from '../render/surface';
import { DrawMeter } from '../core/game-draw';

export function drawHudStats(): void {
  draw_text(S(3), S(3), `Psi Crystals: ${G.player_gems}`, 200);
  draw_text(S(3), S(11), `Explored: ${(G.explored / 30.0).toFixed(1)}% (${G.explored}/3000 rooms)`, 200);
  draw_text(
    S(3),
    S(19),
    `Cleared: ${((G.killed_enemies / G.total_enemies) * 100.0).toFixed(1)}% (${G.killed_enemies}/${G.total_enemies} monsters)`,
    200
  );
}

export function drawHudMeters(t: number): void {
  draw_text(S(316), S(3), 'Shield', G.player_gems >= upgradePrice(0) && G.player_shield !== 30 ? 231 + (t % 13) * 2 : 200);
  DrawMeter(434, 3, G.player_shield);
  draw_text(S(316), S(11), 'Charge', G.player_gems >= upgradePrice(1) && G.circuit_fillrate !== 30 ? 231 + (t % 13) * 2 : 200);
  DrawMeter(434, 11, G.circuit_fillrate);
  draw_text(S(316), S(19), 'Refill', G.player_gems >= upgradePrice(2) && G.circuit_recoverrate !== 30 ? 231 + (t % 13) * 2 : 200);
  DrawMeter(434, 19, G.circuit_recoverrate);
}

function upgradePrice(t: number): number {
  switch (t) {
    case 0:
      return (100 - G.training * 50) * G.player_shield + (5 << G.player_shield) * (5 - G.training * 2);
    case 1:
      return (80 - G.training * 40) * G.circuit_fillrate + (5 << G.circuit_fillrate) * (4 - G.training * 2);
    case 2:
      return (80 - G.training * 40) * G.circuit_recoverrate + (5 << G.circuit_recoverrate) * (4 - G.training * 2);
    default:
      return 123;
  }
}
